
export default [
    {
        "name": "客房统计数字-间夜数",
        "code": "客房统计数字",
        "sort": 0,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务散客",
        "code": "商务散客",
        "sort": 1,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲散客",
        "code": "休闲散客",
        "sort": 2,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务团",
        "code": "商务团",
        "sort": 3,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲团",
        "code": "休闲团",
        "sort": 4,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "其他",
        "code": "其他",
        "sort": 5,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "免费房",
        "code": "免费房",
        "sort": 6,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "已售房合计（不含免费房）",
        "code": "不含免费房",
        "sort": 7,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "已售房合计（包含免费房）",
        "code": "含免费房",
        "sort": 8,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "房间总计",
        "code": "房间总计",
        "sort": 9,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "自用房",
        "code": "自用房10",
        "sort": 10,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "坏房（六个月以上）",
        "code": "坏房11",
        "sort": 11,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "可售房（剔除自用房和六个月以上的坏房）",
        "code": "可售房12",
        "sort": 12,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "客人数",
        "code": "客人数13",
        "sort": 13,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "住房率",
        "code": "住房率14",
        "sort": 14,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务散客",
        "code": "商务散客15",
        "sort": 15,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲散客",
        "code": "休闲散客16",
        "sort": 16,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务团",
        "code": "商务团17",
        "sort": 17,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲团",
        "code": "休闲团18",
        "sort": 18,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "其他",
        "sort": 19,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "免费房",
        "sort": 20,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "住房率",
        "sort": 21,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "平均房价",
        "sort": 22,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务散客",
        "sort": 23,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲散客",
        "sort": 24,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务团",
        "sort": 25,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲团",
        "sort": 26,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "其他",
        "sort": 27,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "免费房",
        "sort": 28,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "已售房平均房价",
        "sort": 29,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "平均每房收入",
        "sort": 30,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "客房收益",
        "sort": 31,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务散客",
        "sort": 32,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲散客",
        "sort": 33,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "商务团",
        "sort": 34,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "休闲团",
        "sort": 35,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "其他",
        "sort": 36,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "免费房",
        "sort": 37,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    },
    {
        "name": "客房收入合计",
        "sort": 38,
        "actual": 0,
        "mtd": 0,
        "budget": 0,
        "budgetDiff": 0,
        "forecast": 0,
        "forecastDiff": 0,
        "last": 0,
        "lastDiff": 0
    }
]



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.3/data.js